import { COLOR_NEUTRAL_SIX, COLOR_NEUTRAL_TWO } from '@myre/common-styles';

import { type ChartOptions } from 'chart.js';

import { defaultTooltip } from '../constants';

import { type BarOrLineChart } from './chart-bar-line.component';
import {
  defaultOptionsBarLineChart,
  zoomOptionsBarLineChart,
} from './constants';

export function optionsBarLineChart(
  stacked: boolean,
  transformY: (value: string) => string,
): Partial<ChartOptions<BarOrLineChart>> {
  return {
    ...defaultOptionsBarLineChart,
    scales: {
      x: {
        stacked,
        ticks: {
          color: COLOR_NEUTRAL_SIX,
        },
      },
      y: {
        // `stacked && 'single'` is inferred as `"" | "single"` against chart.js's option type
        // eslint-disable-next-line unicorn/prefer-logical-operator-over-ternary
        stacked: stacked ? 'single' : false,
        type: 'linear',
        position: 'left',
        grid: {
          color: COLOR_NEUTRAL_TWO,
        },
        ticks: {
          color: COLOR_NEUTRAL_SIX,
          callback: (value: string | number): string =>
            transformY(String(value)),
        },
        border: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        ...defaultTooltip,
        callbacks: {
          label: obj =>
            `${obj.dataset.label}: ${transformY(obj.parsed.y.toString())}`,
        },
      },
      zoom: {
        ...zoomOptionsBarLineChart,
      },
      legend: {
        display: false,
        labels: {
          generateLabels: (chart: unknown): any[] =>
            // @ts-expect-error
            chart.data.datasets.map((dataset, index) => ({
              index,
              text: dataset.label,
              fillStyle:
                dataset.type === 'bar'
                  ? dataset.backgroundColor
                  : dataset.borderColor,
              hidden: dataset.hidden,
            })),
        },
      },
    },
  };
}
